<template>
  <select 
    class="app-select" 
    v-bind="$attrs" 
    v-on="inputListeners"
    :value="value"
  >
    <slot name="first"></slot>
    <template v-if="options">
      <option 
        v-for="(opt, idx) in normalizedOptions" 
        :key="idx" 
        :value="opt.value"
        :disabled="opt.disabled"
      >
        {{ opt.text }}
      </option>
    </template>
    <slot></slot>
  </select>
</template>

<script>
export default {
  name: 'AppSelect',
  inheritAttrs: false,
  props: {
    value: {
      default: null
    },
    options: {
      type: Array,
      default: null
    }
  },
  computed: {
    normalizedOptions() {
      if (!this.options) return []
      return this.options.map(opt => {
        if (typeof opt === 'string' || typeof opt === 'number') {
          return { value: opt, text: opt }
        }
        return opt
      })
    },
    inputListeners() {
      const vm = this
      return Object.assign({},
        this.$listeners,
        {
          // Override both 'input' and 'change' so the raw DOM Event object
          // never reaches the parent — always emit the extracted string value.
          input: function (event) {
            vm.$emit('input', event.target.value)
          },
          change: function (event) {
            vm.$emit('input', event.target.value)
            vm.$emit('change', event.target.value)
          }
        }
      )
    }
  },
  watch: {
    options() {
      // Options are often populated asynchronously after `value` was already
      // set, and Vue won't re-apply the select value when the value prop
      // hasn't changed. Re-apply it once the new options are rendered.
      this.$nextTick(() => {
        const val = this.value
        if (this.$el && (typeof val === 'string' || typeof val === 'number')) {
          this.$el.value = val
        }
      })
    }
  }
}
</script>

<style scoped>
.app-select {
  display: block;
  width: 100%;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: var(--app-font-size-base, 1rem);
  font-weight: 400;
  line-height: var(--app-line-height, 1.5);
  color: var(--app-text-color, #495057);
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat;
  border: 1px solid var(--app-border-color, #ced4da);
  border-radius: var(--app-border-radius, 0.25rem);
  appearance: none;
}
.app-select:focus {
  border-color: var(--app-primary);
  outline: 0;
  box-shadow: 0 0 0 0.2rem var(--app-primary-focus, rgba(15, 40, 53, 0.25));
}
.app-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
</style>
